import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteTradeTermMutation} from 'api';
import {useSnackbar} from 'notistack';

function TradeTermDeleteIconButton({tradeTermId}) {
  const [deleteTradeTerm, deleteTradeTermResult] = useDeleteTradeTermMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteTradeTerm(tradeTermId).unwrap();
      enqueueSnackbar('TradeTerm deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting TradeTerm`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete TradeTerm</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this TradeTerm?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteTradeTermResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteTradeTermResult.isLoading}
            color="error"
            endIcon={deleteTradeTermResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteTradeTermResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default TradeTermDeleteIconButton;
